// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__W9RKl","select":"Header_select__2m-hR","clinic":"Header_clinic__2t5RH"};